import { ConfigService } from './config.service';
import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { CrashService } from './crash.service';
import firebase from 'firebase/app';
import 'firebase/firestore';

export interface CodeResponse {
  phone: string;
  code: string;
  status: string;
  access_token: string;
}

@Injectable({
  providedIn: 'root',
})
export class SmsCodeService {
  constructor(
    private crash: CrashService,
    private router: Router,
    private http: HttpClient,
    private config: ConfigService,
  ) {}

  // Http Options
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  // Handle API errors
  // JL_TOTDO: handle this as a crash
  handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      this.crash.process('sms-code-service', 'login', error.error.message, {
        error,
      });
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      // JL_TODO: test this to make sure it doesn't crash the final stringified data in crash report
      this.crash.process(
        'sms-code-service',
        'login',
        `Backend returned code ${error.status}`,
        {
          body: JSON.stringify(error.error),
        },
      );
    }
    // JL_TODO: throw up a toast telling the user to try again later (or contact support?)
    return throwError('Something bad happened; please try again later.');
  }

  // Verify user credentials on server to get token
  login(data): Observable<CodeResponse> {
    return this.http
      .post<CodeResponse>(this.config.tokenUrl, data, this.httpOptions)
      .pipe(retry(2), catchError(this.handleError));
  }

  mockReply(data): Observable<CodeResponse> {
    const { teamPhone, memberPhone, replyMessage, mediaData } = data;
    const postData = {
      To: teamPhone,
      From: memberPhone,
      Body: replyMessage,
      NumMedia: mediaData.length,
    };
    const apiUrl =
      'http://localhost:5001/gsd-playground/us-central1/messageReceive';
    // 'https://us-central1-gsd-playground.cloudfunctions.net/messageReceive';
    return this.http
      .post<CodeResponse>(apiUrl, postData, this.httpOptions)
      .pipe(retry(2), catchError(this.handleMockError));
  }

  sendMockReply(data) {
    try {
      this.mockReply(data).subscribe(
        (response) => {
          console.log('mock response', response);
        },
        (error) => {
          console.log('mock response error', error);
        },
      );
    } catch (err) {
      console.log('mock reply error', err);
    }
  }

  mockResponse(teamPhone, memberPhone, response) {
    try {
      this.mockResponseSend(teamPhone, memberPhone, response).subscribe(
        (result) => {
          console.log('mock acceptance', result);
        },
        (error) => {
          console.log('mock acceptance error', error);
        },
      );
    } catch (err) {
      console.log('send mock acceptance error', err);
    }
  }

  mockResponseSend(teamPhone, memberPhone, response): Observable<CodeResponse> {
    const postData = {
      To: teamPhone,
      From: memberPhone,
      Body: response,
      MessageSid: 'd092c5b0-8bcc-454a-a778-ca7dfe87e14f',
      NumMedia: 0,
    };
    const apiUrl =
      // JL_TODO: make this change based on emulator/environment settings
      'http://localhost:5001/gsd-playground/us-central1/messageReceive';
    // 'https://us-central1-gsd-playground.cloudfunctions.net/messageReceive';
    return this.http
      .post<CodeResponse>(apiUrl, postData, this.httpOptions)
      .pipe(retry(0), catchError(this.handleMockError));
  }

  // Handle API errors
  handleMockError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('A mock error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Mock backend returned code ${error.status}, ` +
          `body was: ${JSON.stringify(error.error)}`,
      );
    }
    // return an observable with a user-facing error message
    return throwError('Something mock happened; please try again later.');
  }

  // sendMockAcceptance(member, teamId) {
  //   firebase
  //     .firestore()
  //     .collection('teams')
  //     .doc(teamId)
  //     .get()
  //     .then((team) => {
  //       const teamData = team.data();
  //       const teamPhone = teamData?.teamPhoneFull;

  //       firebase
  //         .firestore()
  //         .collection('team-members')
  //         .where('teamMemberTeamId', '==', teamId)
  //         .get()
  //         .then((teamMemberSnap) => {
  //           teamMemberSnap.forEach((teamMember) => {
  //             if (teamMember.id === member.memberId) {
  //               const teamMemberData = teamMember.data();
  //               const memberPhone =
  //                 '+' +
  //                 teamMemberData.teamMemberMobileNumber.full.replace(/\D/g, '');
  //               console.log('accept invite mocked for', teamPhone, memberPhone);
  //               this.mockResponse(teamPhone, memberPhone).subscribe(
  //                 (response) => {
  //                   console.log('mock acceptance', response);
  //                 },
  //                 (error) => {
  //                   console.log('mock acceptance error', error);
  //                 },
  //               );
  //             }
  //           });
  //         })
  //         .catch((error) => {
  //           console.log('messageBroadcast.onCreate Error', error);
  //         });
  //     })
  //     .catch((error) => {
  //       console.log('messageBroadcast.onCreate Error', error);
  //     });
  // }
}
